import React from 'react';

import useSummary from '../useSummary';
import * as M from 'styles/mobile';

function Activity() {
  const summary = useSummary();

  const rows: [string, string][] = [
    ['신청 횟수', `${summary.total}회`],
    ['총 봉사 시간', `${summary.hours}시간`],
    ['출석 횟수', `${summary.present}회`],
    ['지각 횟수', `${summary.late}회`],
    ['결석 횟수', `${summary.absent}회`],
  ];

  return (
    <div css={M.card}>
      <dl css={M.infoList}>
        {rows.map(([label, value]) => (
          <div key={label} css={M.infoRow}>
            <dt>{label}</dt>
            <dd>{value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}

export default Activity;
